import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

/** Ein Mitarbeiter, wie ihn die @-Vorschlagsliste zeigt. */
export type Nutzer = {
  id: number;
  username: string;
  kuerzel: string;
  name: string;
  farbe: string | null;
  symbol: string | null;
};

export function useNutzer() {
  return useQuery({
    queryKey: ['nutzer'],
    queryFn: () => apiFetch<{ nutzer: Nutzer[] }>('/nutzer.php'),
    // Die Belegschaft ändert sich selten. Zehn Minuten sind derselbe Wert
    // wie bei den Konfigurations-Listen.
    staleTime: 10 * 60_000
  });
}
